<p-dialog
  [appendTo]="'body'"
  [ngClass]="{ 'fixed left-0 top-0 z-50 h-full w-full bg-black bg-opacity-10 backdrop-blur-sm': visible }"
  [(visible)]="visible"
  [style]="{ width: '30rem', height: '20rem', margin: '0 2rem 0 2rem' }">
  <ng-template pTemplate="headless">
    <div class="grid h-full w-full grid-cols-1 grid-rows-6 gap-4 rounded-lg bg-gray-100">
      <div class="col-span-1 row-span-6 mb-3 flex flex-col justify-center gap-4 px-8 md:mb-0">
        <div class="text-center text-xl font-black text-primary-500 md:text-3xl">
          <div [innerHTML]="'¡Bienvenido a TOLIS Empresas!'"></div>
          <!-- <div class="text-center text-lg font-bold text-gray-500">
            <div [innerHTML]="'Tu boleto a la libertad'"></div>
          </div> -->
        </div>
        <div class="text-center text-gray-500">
          <div
            [innerHTML]="
              'Estás a solo unos pasos de comenzar a disfrutar de todos los beneficios de esta nueva forma de viajar. <br>Vamos a ayudarte a configurar todo de forma rápida y sencilla.'
            "></div>
        </div>
        <div class="flex flex-col gap-2 text-center text-gray-500">
          <input
            type="button"
            class="btn-primary cursor-pointer"
            name="comenzar-tour"
            value="Comenzar"
            (click)="startTour()" />
          <input
            type="button"
            class="cursor-pointer font-bold text-gray-400"
            name="saltar-tour"
            value="Omitir"
            (click)="closeModal()" />
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
